import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import FaqComponent from "../../Components/Footer/FaqComponent/FaqComponent";
import ButtonComponent from "../../Components/Buttons/ButtonComponent";
import OurClients from "../../Components/OurClientSection/OurClients";
import TestimonialComponent from "../../Components/Testimonial/TestimonialComponent";
import PickIndustryComponent from "./PickIndustryComponent";
import { Helmet } from "react-helmet-async";
const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";
const bg_image = `${digitalOceanURL}/About_Us_img/About_bg.png`;
const indHeroImg = `${digitalOceanURL}/HelpCardAssets/allIndustries.png`;
const jsonLdData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "BreadcrumbList",
      "@id": "https://hirestar.io/industries/#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://hirestar.io/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Industries",
          item: "https://hirestar.io/industries/",
        },
      ],
    },
    {
      "@type": "ItemList",
      "@id": "https://hirestar.io/industries/#services",
      name: "Comprehensive Authentication Platform for Industries",
      url: "https://hirestar.io/industries/",
      description:
        "blockchain & AI powered authentication platform delivering industry-specific verification and due diligence services. Customized solutions for every sector to ensure trust and compliance.",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          item: {
            "@type": "Service",
            name: "Banking & Finance Verification",
            description:
              "Robust background verification tailored for the banking and finance sector, ensuring compliance, fraud prevention, and trust through AI and blockchain-powered screening.",
            url: "https://hirestar.io/industries/banking",
            provider: {
              "@type": "Organization",
              name: "HireStar.io",
              url: "https://hirestar.io",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 2,
          item: {
            "@type": "Service",
            name: "Healthcare and Pharma Industry Verification",
            description:
              "Thorough background checks for medical professionals to verify licenses, qualifications, and employment history—ensuring patient safety and regulatory compliance.",
            url: "https://hirestar.io/industries/healthcare",
            provider: {
              "@type": "Organization",
              name: "HireStar.io",
              url: "https://hirestar.io",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 3,
          item: {
            "@type": "Service",
            name: "Online-Gaming Industry Verification",
            description:
              "Comprehensive verification services for the online gaming industry to ensure secure hiring, prevent fraud, and maintain trust among players and partners.",
            url: "https://hirestar.io/industries/online-gaming",
            provider: {
              "@type": "Organization",
              name: "HireStar.io",
              url: "https://hirestar.io",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 4,
          item: {
            "@type": "Service",
            name: "Education Verification Services",
            description:
              "Thorough background checks for the education sector to verify academic qualifications, employment history, and criminal records of teachers and staff.",
            url: "https://hirestar.io/industries/education",
            provider: {
              "@type": "Organization",
              name: "HireStar.io",
              url: "https://hirestar.io",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 5,
          item: {
            "@type": "Service",
            name: "Manufacturing Industry Verification",
            description:
              "End-to-end background verification services for the manufacturing industry—validating worker credentials, employment history, and criminal records to ensure a safe and compliant workforce.",
            url: "https://hirestar.io/industries/manufacturing",
            provider: {
              "@type": "Organization",
              name: "HireStar.io",
              url: "https://hirestar.io",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 6,
          item: {
            "@type": "Service",
            name: "Travel and Hospitality Industry Verification",
            description:
              "Comprehensive background verification services for the travel and hospitality industry—ensuring trustworthy staff, secure guest experiences, and regulatory compliance.",
            url: "https://hirestar.io/industries/travel",
            provider: {
              "@type": "Organization",
              name: "HireStar.io",
              url: "https://hirestar.io",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 7,
          item: {
            "@type": "Service",
            name: "Freelancer & Gig Worker Background Checks",
            description:
              "Fast and reliable background verification for gig workers, freelancers, and contract staff—ensuring safety, trust, and compliance for on-demand platforms.",
            url: "https://hirestar.io/industries/gig-workers",
            provider: {
              "@type": "Organization",
              name: "HireStar.io",
              url: "https://hirestar.io",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 8,
          item: {
            "@type": "Service",
            name: "Logistics & Supply Chain Employee Screening",
            description:
              "Comprehensive background verification services for logistics and supply chain staff—ensuring trustworthy drivers, handlers, and warehouse personnel to maintain operational integrity and security.",
            url: "https://hirestar.io/industries/logistics",
            provider: {
              "@type": "Organization",
              name: "HireStar.io",
              url: "https://hirestar.io",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 10,
          item: {
            "@type": "Service",
            name: "FMCG & FMCD Employee Background Verification",
            description:
              "HireStar.io provides specialized background verification services for the FMCG and FMCD industries—verifying sales staff, warehouse workers, and distribution personnel to ensure trust, safety, and compliance across fast-paced supply chains.",
            url: "https://hirestar.io/industries/fmcg-fmcd",
            provider: {
              "@type": "Organization",
              name: "HireStar.io",
              url: "https://hirestar.io",
            },
          },
        },
        {
          "@type": "ListItem",
          position: 11,
          item: {
            "@type": "Service",
            name: "IT & ITES Employee Background Verification",
            description:
              "Comprehensive background screening for IT and ITES professionals—covering employment history, education credentials, identity, and criminal records to help tech companies hire trusted and qualified talent.",
            url: "https://hirestar.io/industries/it-ites",
            provider: {
              "@type": "Organization",
              name: "HireStar.io",
              url: "https://hirestar.io",
            },
          },
        },
      ],
    },
  ],
};
const AllIndustries = () => {
  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
        <title>
          Simplify Employee Onboarding & Verification for Enterprises |
          Hirestar.io
        </title>
        <meta
          name="description"
          content="Hirestar.io: AI-powered verification & onboarding for BFSI, Healthcare, IT, E-commerce, & more. Ensure compliance, trust, and efficiency in hiring."
        />
        <meta
          name="keywords"
          content="industry verification solutions, background checks by industry, digital onboarding, identity verification, Hirestar.io industries, compliance solutions, employee onboarding, employee screening services, secure employee onboarding"
        />

        <meta property="og:site_name" content="HireStar.io" />
        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta property="og:locale" content="en_US" />

        <meta property="og:title" content="Industries" />
        <meta
          property="og:description"
          content="Hirestar.io: AI-powered verification & onboarding for BFSI, Healthcare, IT, E-commerce, & more. Ensure compliance, trust, and efficiency in hiring."
        />
        <meta property="og:url" content="https://hirestar.io/industries" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={indHeroImg} />
        <meta property="og:image:type" content="image/png" />

        <meta name="robots" content="index, follow" />

        <meta name="robots" content="index, follow" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Simplify Employee Onboarding & Verification for Enterprises | Hirestar.io"
        />
        <meta
          name="twitter:description"
          content="Hirestar.io: AI-powered verification & onboarding for BFSI, Healthcare, IT, E-commerce, & more. Ensure compliance, trust, and efficiency in hiring."
        />
        <meta name="twitter:image" content={indHeroImg} />
      </Helmet>
      <div className="relative  background_color  ">
        {/* Image that is hidden on small screens */}
        {/* if breaks add object-cover in the given img */}
        <img
          src={bg_image}
          alt="hero img for banking sector"
          className="absolute   w-full lg:h-[150%] h-[110%] md:h-[120%] bg_curve_img"
        />

        <div className="mb-16 relative  w-full h-full md:top-28 lg:top-0 ">
          <div className="grid grid-cols-12 gap-4 justify-items-center relative top-0 lg:top-32 lg:mx-20 xl:mx-32 2xl:mx-40 items-center ">
            {/* Text container */}
            <div className="col-span-12 md:col-span-12 lg:col-span-7  Banking_heading font-semibold font-[poppins]  top_spacing mx-2 lg:mx-0">
              <h1 className="w-full text-[32px] md:text-[40px] lg:text-[46px]">
                Your Trusted
              </h1>
              <p className="w-full text-[32px] md:text-[40px] lg:text-[46px]">
                Verification Platform
              </p>
              <p className="w-full text-[32px] md:text-[40px] lg:text-[46px]">
                Across Industries
              </p>
              {/* h2 heading */}
              <h2 className="about-text-para mt-2 ">
                Enhance your operations with solutions that comply with
                regulations and foster trust throughout your digital onboarding
                and verification processes.
              </h2>

              {/* Button Group */}
              <div className="mt-4">
                <ButtonComponent
                  arialLabel={
                    "Get in touch with an expert for automated background checks in Banking sector"
                  }
                />
              </div>
            </div>

            {/* Image container */}
            <div className="col-span-12 md:col-span-12 lg:col-span-5 relative mx-2  bottom_space lg:mb-0 mb-20">
              <img
                src={indHeroImg}
                alt="about-girl banking sector"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="lg:mt-72 mt-44">
        <OurClients />
      </div>

      <PickIndustryComponent />
      <TestimonialComponent />

      <FaqComponent />
      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </>
  );
};

export default AllIndustries;
